import { ScopeVersion } from '@app/core/model/scope-version'
import { moveItemInArray } from '@angular/cdk/drag-drop'

export const remapDeliverablesInTradedHierarchy = (currentScopeInstance: ScopeVersion) => {
  if (!currentScopeInstance.isStateApproved()) return

  const tradedDeliverables = currentScopeInstance.deliverables.filter(
    (del) => del.deliveryStatus === 'TRADING_FROM_IN_PROGRESS'
  )

  tradedDeliverables.forEach((deliverable) => {
    const tradedToDeliverables = currentScopeInstance.deliverables
      .filter((del) => del.tradedFrom?.id === deliverable.id)
      .reverse()
    tradedToDeliverables.forEach((del) => {
      moveItemInArray(
        currentScopeInstance.deliverables,
        currentScopeInstance.deliverables.findIndex((d) => d.id == del.id),
        currentScopeInstance.deliverables.findIndex((d) => d.id == deliverable.id) + 1
      )
      del.order = deliverable.order
    })
    deliverable.tradesCount = tradedToDeliverables.length
  })
}
